module.exports = __webpack_public_path__ + "static/media/Alstom.fb07dfdd.png";